import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../services/user.service';
import {Router} from '@angular/router';
import {FormBuilder, FormGroup} from '@angular/forms';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  username: string;
  password: string;
  error: boolean;
  showSpinner: boolean;
  user: {};
  constructor(private userService: UserService,
              private router: Router,
              private fb: FormBuilder, ) { }



  ngOnInit() {
    this.loginForm = this.fb.group({
      email: [''],
      password: ['']
    });

  }

  login(): void {
    const controls = this.loginForm.controls;
    this.showSpinner = true;

    const authData = {
      email: controls.email.value,
      password: controls.password.value
    };
    this.userService.login(authData.email, authData.password).subscribe( (observer => {
      // Api token
      localStorage.setItem('token', observer.key);
      this.router.navigate(['tagging']);
    }), error => {
      this.error = true;
      this.showSpinner = false;
      console.log('login.page.ts: an error ocurred');
    });

  }

}
